const startingPage = ({ assignment, paragraph, handleNext }) => {
  return (
    <div>
      <div
        style={{
          fontSize: "40px",
          fontWeight: "bold",
          marginBottom: "10px",
          textAlign: "center",
        }}
      >
        {assignment.title}
      </div>
      <div
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        {paragraph.title}
      </div>
      <div style={{ textAlign: "center", marginTop: "100px" }}>
        <button
          style={{
            backgroundColor: "#2DF034",
            color: "#FFF",
            fontSize: "28px",
            fontWeight: "bold",
            padding: "10px 30px",
            borderRadius: "5px",
            border: "none",
          }}
          onClick={() => handleNext()}
        >
          학습 시작하기
        </button>
      </div>
    </div>
  );
};

export default startingPage;
